import { FaqType } from 'api/types';
import React from 'react';
import { Text } from 'shared/components/Text/Text';
import { useNavigate, resolvePath } from 'react-router';
import pages from 'pages';
import handleFocusedKeyPress from 'shared/utils/handleFocusedKeypress';
import { ResultPreviewWrapper } from './FAQSearchResults.styles';

export function SearchResultPreview({ faq }: { faq: FaqType }) {
  const navigate = useNavigate();

  const handleGoToQuestion = () => {
    navigate(resolvePath(`${pages.SUPPORT}/${pages.FAQ_QUESTION.replace(':faqId', faq.id)}`));
  };

  return (
    <ResultPreviewWrapper
      tabIndex={0}
      onClick={handleGoToQuestion}
      onKeyUp={(e) => handleFocusedKeyPress(e, handleGoToQuestion)}
    >
      <Text as="h3" $margin="0 0 8px">
        {faq.question}
      </Text>
      <Text as="p">{faq.answer}</Text>
    </ResultPreviewWrapper>
  );
}

export default SearchResultPreview;
